import { useCallback, useEffect, useState } from "react";
import {
  fetchAdminProfit,
  fetchAdminOccupancy,
} from "../../../api/adminData";

export function useUnitKpi(unitId, kpiYear, kpiMonth) {
  const [unitKpiProfit, setUnitKpiProfit] = useState(null);
  const [unitKpiOcc, setUnitKpiOcc] = useState(null);
  const [unitKpiLoading, setUnitKpiLoading] = useState(false);
  const [unitKpiErr, setUnitKpiErr] = useState(null);

  const reloadUnitKpi = useCallback(async () => {
    if (!unitId) return;
    setUnitKpiLoading(true);
    setUnitKpiErr(null);
    try {
      const [profitRes, occRes] = await Promise.all([
        fetchAdminProfit({ unit_id: unitId, year: kpiYear, month: kpiMonth }),
        fetchAdminOccupancy({ unit_id: unitId }),
      ]);
      const row = Array.isArray(profitRes?.units)
        ? profitRes.units.find((x) => String(x.unit_id) === String(unitId))
        : null;
      setUnitKpiProfit(
        row
          ? {
              revenue: Number(row.revenue),
              costs: Number(row.costs),
              profit: Number(row.profit),
            }
          : null
      );
      const occ =
        occRes?.units && Array.isArray(occRes.units)
          ? occRes.units.find((x) => String(x.unit_id) === String(unitId))
          : null;
      setUnitKpiOcc(occ || null);
    } catch (e) {
      setUnitKpiErr(e?.message || "KPI konnten nicht geladen werden.");
      setUnitKpiProfit(null);
      setUnitKpiOcc(null);
    } finally {
      setUnitKpiLoading(false);
    }
  }, [unitId, kpiYear, kpiMonth]);

  useEffect(() => {
    reloadUnitKpi();
  }, [reloadUnitKpi]);

  return {
    unitKpiProfit,
    unitKpiOcc,
    unitKpiLoading,
    unitKpiErr,
    reloadUnitKpi,
  };
}
